<div class="wrap-tutorial-screen" *ngIf="isActive()">
  <div class="tutorial-slides" #slider>
    <div class="tutorial-slide">
      <img class="img" src="assets/images/tutorial_01.png">
    </div>
    <div class="tutorial-slide">
      <img class="img" src="assets/images/tutorial_02.png">
    </div>
    <div class="tutorial-slide">
      <img class="img" src="assets/images/tutorial_03.png">
    </div>
    <div class="tutorial-slide">
      <img class="img" src="assets/images/tutorial_04.png">
    </div>
    <div class="tutorial-slide">
      <img class="img" src="assets/images/tutorial_05.png">
    </div>
  </div>

  <ul class="tutorial-button-box" *ngIf="showButtons">
    <li class="btn" (click)="neverShowTutorial()">
      <img src="assets/images/tutorial_icon_01.png" class="img">
    </li>
    <li class="btn" (click)="closeTutorial()">
      <img src="assets/images/tutorial_icon_02.png" class="img">
    </li>
  </ul>
</div>
